export { default } from './TooltipedSortLabel';
export { SORT_DIRECTIONS, SORT_LABEL_ALIGNMENT } from './TooltipedSortLabel.constants';
